import { makeAPIRequest } from "./makeRequest";

export const GetVinNotes = (data: string, id: any) => {
    let config = {
        method: 'GET',
        url: process.env.REACT_APP_SERVER_URL + 'ScannedVehicleNotes/GetData?dealid=' + id + '&vinsfornotes=' + data,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    }

    let res = makeAPIRequest(config);
    return res;
}